import { css } from 'linaria';
import { PillProps, Variables } from '../index';

export const disabled = css`
    opacity: 0.5;
`;

export const clearable = css`
    &:hover {
        text-decoration: underline;
        text-decoration-thickness: 1px;
        text-underline-offset: 2px;
    }
    &.dark {
        text-decoration-color: ${Variables.css.catapultBlack};
    }

    &:not(.dark) {
        text-decoration-color: ${Variables.css.catapultWhite};
    }
`;

export const shape: Record<PillProps['shape'], string> = {
    round: css`
        border-radius: 16px;
    `,
    square: css`
        border-radius: 4px;
    `,
};

const fontColor = `
    &.dark {
        color: ${Variables.css.catapultBlack};
    }
    
    &:not(.dark) {
        color: ${Variables.css.catapultWhite};
    }
`;

export const root = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const size: Record<PillProps['size'], string> = {
    small: css`
        min-height: ${Variables.css.spacing16};
        gap: ${Variables.css.spacing4};
        padding: 0 4px 0 4px;
    `,
    medium: css`
        gap: ${Variables.css.spacing8};
        min-height: ${Variables.css.spacing24};
        padding: 4px 8px 4px 8px;
    `,
};

export const staticPill = css`
    // Override states
    &::after {
        width: auto;
    }

    svg {
        height: 12px;
    }

    ${fontColor}
`;

export const text = css`
    font-weight: 700;

    ${fontColor}
`;

export const closeButton = css`
    z-index: 1;

    cursor: pointer;
`;

export const adornmentContainer = css`
    display: flex;

    ${fontColor}
`;

export const variants: Record<PillProps['variant'], string> = {
    neutral: css`
        background: ${Variables.css.neutral};
    `,
    alert: css`
        background: ${Variables.css.alert};
    `,
    success: css`
        background: ${Variables.css.success};
    `,
    warning: css`
        background: ${Variables.css.warning};
    `,
    information: css`
        background: ${Variables.css.information};
    `,
    onboarding: css`
        background: ${Variables.css.onboarding};
    `,
    clearable: css`
        background: ${Variables.css.clearable};
    `,
    alertText: css`
        background: ${Variables.css.alertText};
    `,
    successText: css`
        background: ${Variables.css.successText};
    `,
    warningText: css`
        background: ${Variables.css.warningText};
    `,
    informationText: css`
        background: ${Variables.css.informationText};
    `,
};
